/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { ServiceCardContainer } from './styles'
import { Text, Header2 } from '../../styles/Components'
import { useRouter } from 'next/router'
import { generateServiceCardPrice } from '../../helpers'

// Card component for each service within service section
const ServiceCard = ({ service, market, showOnlyBookButton = false }) => {
  const router = useRouter()

  const handleClick = (event) => {
    if (service.service.serviceType.name === 'Weddings') {
      event.preventDefault()
      router.push('/weddings')
      return
    }
    if (service?.service?.isInformational) {
      if (service?.service?.informationalUrl) {
        window.open(
          service.service.informationalUrl,
          '_blank',
          'noopener, noreferrer',
        )
      }
      return
    }
    router.push(
      `/book/?mkt=${encodeURI(market?.shortName)}&stp=${encodeURI(
        service.service.serviceType.name.toLowerCase(),
      )}&svc=${encodeURI(service.service.name.toLowerCase())}`,
    )
  }

  const price = generateServiceCardPrice(service, market)

  return (
    <ServiceCardContainer onClick={handleClick}>
      <div className="top-container">
        <Header2
          fontSize={32}
          lineHeight="140%"
          spacing={0.282}
          margin="0 0 6px"
        >
          {service.service.name}
        </Header2>
        <Text variant="medium" lineHeight="145%" spacing={0.22}>
          {service.service.description}
        </Text>
      </div>

      <div className="bottom-container">
        <div className="service-card-footer">
          <div className="service-card-info">
            {/* {!!service.price && (<Text lineHeight='145%' spacing={0.16} weight={600}>Starting at: {price}</Text>)} */}
            {!!price && (
              <Text lineHeight="145%" spacing={0.16} weight={600}>
                Starting at: {price}
              </Text>
            )}
            {/* {(!service.price && service?.service?.informationalPriceText) && (<Text lineHeight='145%' spacing={0.16} weight={600}>Starting at: {price}</Text>)} */}
            <div className="service-time-container">
              {!!service.duration && (
                <>
                  <img src="/images/book-icon-time.svg" alt="clock icon" />
                  <Text lineHeight="145%" spacing={0.16}>
                    {service.duration} mins
                  </Text>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="button-container">
          {service.service.isInformational && !showOnlyBookButton ? (
            <a className="service-card-informational-button">
              <Text fontSize={18} variant="small" weight={600}>
                Learn More
              </Text>
            </a>
          ) : (
            <button className="service-card-book-button">
              <Text fontSize={18} variant="small" weight={600}>
                Book Now
              </Text>
            </button>
          )}
        </div>
      </div>
    </ServiceCardContainer>
  )
}

export default ServiceCard
